import React from 'react';
import FormTextInputConfig from '@packages/shared/render/plugins/Form/FormTextInput';
import {
  USYS_DATA_ATTRS,
  RESERVED_USER_FIELDS,
} from '@packages/systems/users/constants';
import {qualify, typeName, pluginName} from '@packages/systems/wfdl-Qualified';
import {Atom} from '@packages/systems/wfdl';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {appendUserInputClasses} from '@packages/systems/users/utils/universalUtils';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {getInPojo, getString} from '@packages/utilities/data-utils';

const {DESIGNER} = WebflowEnvironments;

const UserFormTextInput = Atom.createRender(
  ({attributes, classes, generateAttributes, context, data}) => {
    const inputClasses = appendUserInputClasses(data, classes);
    const field = getString(getInPojo(data, ['users', 'field']));
    const fieldType = getString(getInPojo(data, ['users', 'fieldType']));
    const runtimeEnvironment = useRuntimeEnvironment();
    const mockValue =
      field === RESERVED_USER_FIELDS.name
        ? context.get('data')?.name
        : context.get('data')?.mockCustomTextField;

    // Set mock user name as value for user account page
    if (runtimeEnvironment === DESIGNER && mockValue)
      attributes = attributes.set('value', mockValue);

    const attributeWithField = field
      ? attributes.set(USYS_DATA_ATTRS.field, field)
      : attributes;

    return (
      <input
        {...generateAttributes(
          fieldType
            ? attributeWithField.set(USYS_DATA_ATTRS.fieldType, fieldType)
            : attributeWithField,
          inputClasses
        )}
      />
    );
  }
);

const config = Atom.create({
  ...Atom.getConfigShape(FormTextInputConfig),
  constraints: {
    ancestors: [
      {
        is: ['UserSignUpForm', 'UserAccountForm'],
        name: 'User Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: UserFormTextInput,
  dataType: createIntegratedRootAliasInstance(
    qualify(pluginName('Form'), typeName('UserFormTextInput'))
  ),
});

export default config;
